// extracted by mini-css-extract-plugin
export default {"pageWrap":"yc-z","fullWidth":"zc-z","heading":"Ac-z","fullBleed":"Bc-z","hidden":"Cc-z"};